import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import _ from 'lodash';

import DenverStory1 from './DenverStory1';
import DenverStory2 from './DenverStory2';
import DenverStory3 from './DenverStory3';
import DenverStory4 from './DenverStory4';

import { getDonorsFromFolder } from '../../../utils/donorHelpers';
import DenverDonorList from './DenverDonorList';

export default class extends Component {

  constructor(props) {
    super(props);
    this.state = {
      storyIndex: -1
    };
    this._templateCycleSeconds = 0;
    this._donorListRef = null;
    this._paused = false;
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }
  3
  componentDidUpdate(prevProps, prevState) {
    // Only run if donor list mounted
    if (this._donorListRef) {
      //this._donorListRef.timedCycle();
    }
  }
  
  handleKeyDown = (event) => {
    switch (event.keyCode) {
      // Start/stop: spacebar
      case 32:
        this._paused = !this._paused;
        break;
      // Pause and show prev story: left arrow
      case 37:
        this._paused = true;
        this.setState((prevState) => {
          return prevState.storyIndex - 1 >= 0 ?
            { storyIndex: prevState.storyIndex - 1 } :
            { storyIndex: this.props.stories.length - 1 };
        }, this.timedCycle);
        break;
      // Pause and show next story: right arrow
      case 39:
        this._paused = true;
        this.setState((prevState) => {
          return prevState.storyIndex < this.props.stories.length - 1  ?
            { storyIndex: prevState.storyIndex + 1 } :
            { storyIndex: 0 };
        }, this.timedCycle);
        break;
      default:
        break;
    }
  }

  timedCycle = () => {
    if (this._paused) {
      console.log(this._paused);
      return null;
    }
    this._templateCycleSeconds--;
    if (this._templateCycleSeconds < 0) {
      const folderType = this.getFolderType();
      //do not auto cycle the 
      if (folderType==='donor_list'){
        return null;
      }
      this.performCycle();
    }
  }

  performCycle = () => {
    this.setState((prevState) => {
      let storyIndex = 0;
      if (prevState.storyIndex < this.props.stories.length - 1) {
        storyIndex = prevState.storyIndex + 1;
      }
      const cycleTime = _.get(this.props.stories[storyIndex], 'contents.custom_fields.cycle_timeout.val');
      this._templateCycleSeconds = cycleTime || this.props.defaultCycleTime;
      return { ...prevState, storyIndex };
    });
  }

  getFolderType = () => {
    const story = this.props.stories[this.state.storyIndex];
    const folderType = _.get(story, 'contents.custom_fields.folder_type.val.value');
    return folderType;
  }

  getCycleTime() {
    return this.props.cycleTime || this.props.defaultCycleTime;
  }

  getTemplate = () => {
    const story = this.props.stories[this.state.storyIndex];
    if (!story) {
      return null;
    }

    const storyType = _.get(story, 'contents.custom_fields.story_type.val.value');
    const folderType = _.get(story, 'contents.custom_fields.folder_type.val.value');
    const customFields = _.get(story, 'contents.custom_fields');
    const images = _.get(story, 'contents.images', []);

    const commonProps = {
      screen: this.props.screen,
      headline: customFields.headline,
      body: customFields.body,
      quote: customFields.quote,
      images
    };

    if (storyType) {
      
      switch (storyType) {
        case 'template_1':
          return <DenverStory1 {...commonProps}/>;

        case 'template_2':
          return <DenverStory2
            {...commonProps}
            subhead={customFields.subhead}
            lower_right_image_caption={customFields.lower_right_image_caption}
            upper_left_image_caption={customFields.upper_left_image_caption}
            upper_right_image_caption={customFields.upper_right_image_caption}
          />;
        
        case 'template_3':
          return <DenverStory3
            {...commonProps}
            subhead={customFields.subhead}
            upper_left_image_caption={customFields.upper_left_image_caption}
            upper_right_image_caption={customFields.upper_right_image_caption}
          />;
        
        case 'template_4':
          return <DenverStory4
            {...commonProps}
            subhead={customFields.subhead}
            center_image_caption={customFields.center_image_caption}
          />;
        default:
          return null;
      }

    } else if (folderType === 'donor_list') {
      const donorCategories = [{
        ...story,
        donors: getDonorsFromFolder(this.props.donors, this.props.folder_modules, story.id)
      }];
      console.log("passing in categories", donorCategories);

      return <DenverDonorList
        defaultCycleTime={this.props.defaultCycleTime}
        width={window.innerWidth}
        height={window.innerHeight}
        content={this.props.content}
        screen={this.props.screen} // ?
        donorCategories={donorCategories}
        ref={ref => this._donorListRef = ref}
        style={{ position: 'absolute', left: window.innerWidth * 0.085, height: '100vh', width: '100vw' }}
        columns={2}
        rows={22}
        allCategoriesLooped={this.performCycle}
        fsTitleModifier={0.029}
        fsSubheaderModifier={0.014}
        fsNamesModifier={0.57}
        yOffsetTitleModifier={0.02}
        yOffsetSubheaderModifier={0.065}
        yOffsetSubheaderUnderlineModifier={0.2}
        subheaderUnderlineWidthModifier={0.83}

        yOffsetNamesModifier={0.225}
        titleWidthModifier={1}
        descriptionWidthModifier={0.84}
        descriptionLineHeightModifier={0.002}
        hideDonorListName={true}

        targetHeight={1920}
        listTopOffset={window.innerHeight * .24}
        listHeight={window.innerHeight * .7}
        listWidth={window.innerWidth*.83}
        subHeaderFontSize={"1.45vh"}
      />;
    }
    
  }

  render() {
    return (      
      <CSSTransitionGroup
        component='div'
        transitionName='slowfade'
        transitionEnterTimeout={0}
        transitionLeaveTimeout={0}>
        <div key={this.state.storyIndex}>
          {this.getTemplate()}
        </div>
        
      </CSSTransitionGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Theme/Denver/DenverStories.js